import { Sprite, Texture } from 'pixi.js';
import { SVG } from './svg-element';

export interface ImageElementConfig {
  src: string; // Image URL or asset path
  width?: number;
  height?: number;
  x?: number;
  y?: number;
  [key: string]: any;
}

export class ImageElement extends SVG<ImageElementConfig> {
  sprite: Sprite;

  constructor(cs: any, container: any, config: ImageElementConfig, zIndex?: number) {
    super(cs, container, config, zIndex);
    if (container && this.sprite) {
      container.addChild(this.sprite);
    }
  }

  initElement() {
    const texture = Texture.from(this.config.src);
    this._element = new Sprite(texture) as any;
    this.updateAttr();
  }

  updateAttr() {
    // Extend this if you want to update sprite attributes dynamically
    // For now, just set position and size from config
    if (this.element) {
      if (this.config.width) this.element.scale.x = this.config.width;
      if (this.config.height) this.element.scale.y = this.config.height;
      if (this.config.x) this.element.x = this.config.x;
      if (this.config.y) this.element.y = this.config.y;
    }
  }
}
